export const SET_QUESTIONTYPES = "setQuestionTypes";
